import { ProgressDialog } from './ProgressDialog'

interface DeleteProgressDialogProps {
  title: string
  current: number
  total: number
  status?: string
  hint?: string
  onCancel?: () => void
  cancelLabel?: string
}

export function DeleteProgressDialog(props: DeleteProgressDialogProps) {
  return <ProgressDialog {...props} tone="danger" />
}
